import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f25fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-issue" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "label-with-status" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "header-issue" }
const _hoisted_7 = { class: "header-issue" }
const _hoisted_8 = { class: "header-issue" }
const _hoisted_9 = { class: "header-issue" }
const _hoisted_10 = { class: "btn-bottom" }

import {
  ImageLossAlert,
  IssueDiagnosis,
  IssueSolutionExecution,
  IssueType,
} from "@/types/issueMonitoring.type";
import { ref, onMounted, computed, watch } from "vue";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { getIssueType } from "@/service/issueType.service";
import { putImageLossAlert, getIssueOptions } from "@/service/imagelossalert.service";
import { Station } from "@/types/station.type";
import { CircleCheck, CircleClose } from "@element-plus/icons-vue";
import { ElNotification, ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { Filter } from "@/types/filter.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    issue: null,
    diagnosis: null
  },
  emits: ["close", "getIssue"],
  setup(__props: any, { emit }: { emit: ({ (e: "close"): void; (e: "getIssue"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { issue: ImageLossAlert; diagnosis: IssueDiagnosis | null }

const { t } = useI18n();
const activeName = ref("first");
const cameras = ref<{ label: string; value: string; modele: boolean }[]>([]);
const customer = ref("");

const issueCopy = ref<ImageLossAlert>({} as ImageLossAlert);
const diagnosisCopy = ref<IssueDiagnosis>({} as IssueDiagnosis);
const issueSolutionExecution = ref<IssueSolutionExecution>({} as IssueSolutionExecution);




const issueTypeList = ref<IssueType[]>([]);
const filteredDiagnoses = ref<string[]>([]);
const filteredExecutions = ref<string[]>([]);

const selectedDiagnosisManual = ref("");
const customDiagnosisManual = ref("");
const selectedSolutionManual = ref("");
const customSolutionManual = ref("");
const selectedExecution = ref("");
const customExecution = ref("");

const automaticDiagnosisMap: Record<string, string> = {
  CONNECTIVITY: "Error estación - Conectividad (SIM, Módem, Cobertura, etc.)",
  SD_FULL: "Error estación - Memoria SD llena",
  SD_CORRUPT: "Error estación - Archivo SD corrupto",
  FREEZE: "Error estación - SW/HW freeze",
  CAMERAS: "Error estación - Cámaras",
  POSITION: "Error estación - Sensor de posición",
};

const translatedAutomaticDiagnosis = computed(() => {
  const rawCode = diagnosisCopy.value?.diagnosis_automatic;
  if (!rawCode) return "-";
  return automaticDiagnosisMap[rawCode] || rawCode;
});

// watch(
//   () => issueCopy.value.type,
//   async (newType) => {
//     if (newType && newType.key) {
//       try {
//         const res = await getIssueOptions(newType.id);
//         filteredDiagnoses.value = res.diagnoses;
//         filteredExecutions.value = res.executions;
//       } catch (err) {
//         console.error("Error cargando ", err);
//       }
//     }
//   },
//   { deep: true }
// );

onMounted(async () => {
  issueCopy.value = { ...props.issue };
  diagnosisCopy.value = props.diagnosis
    ? { ...props.diagnosis }
    : ({ isManual: false } as IssueDiagnosis);
  issueSolutionExecution.value = props.diagnosis?.issueSolutionExecution
    ? { ...props.diagnosis.issueSolutionExecution }
    : ({ status: "UNREVIEWED" } as IssueSolutionExecution);
  //TODO
  if (issueCopy.value.statusIssue?.includes("DI")) {
    diagnosisCopy.value.status = issueCopy.value.statusIssue.replace("DI-", "") as
      | "UNREVIEWED"
      | "IN_PROGRESS"
      | "REVIEWED";
  } else if (issueCopy.value.statusIssue?.includes("EJ")) {
    issueSolutionExecution.value.status = issueCopy.value.statusIssue.replace("EJ-", "") as
      | "UNREVIEWED"
      | "OPEN"
      | "CLOSE"
      | "OBSERVATION";
    diagnosisCopy.value.status = "REVIEWED";
  } else if (issueCopy.value.statusIssue === "UNREVIEWED") {
    issueSolutionExecution.value.status = "UNREVIEWED";
    diagnosisCopy.value.status = "UNREVIEWED";
  }

  // 1. Traer todos los tipos de incidencias desde BD
  const filterIssue: Filter = { fields: { stationOperation: { operator: "equal", value: true } } };
  issueTypeList.value = await getIssueType(undefined, undefined, filterIssue);

  const diagsSet = new Set<string>();
  const execsSet = new Set<string>();

  for (const item of issueTypeList.value) {
    try {
      const res = await getIssueOptions(item.id);
      res.diagnoses?.forEach((d) => diagsSet.add(d));
      res.executions?.forEach((e) => execsSet.add(e));
    } catch (err) {
      console.error(`Error trayendo opciones para ID ${item.id}:`, err);
    }
  }

  filteredDiagnoses.value = Array.from(diagsSet);
  filteredExecutions.value = Array.from(execsSet);

  const diag = diagnosisCopy.value.diagnosis_manual;
  if (diag) {
    if (filteredDiagnoses.value.includes(diag)) {
      selectedDiagnosisManual.value = diag;
    } else {
      selectedDiagnosisManual.value = "Otros";
      customDiagnosisManual.value = diag;
    }
  }

  const sol = diagnosisCopy.value.solution_proposal_manual;
  if (sol) {
    selectedSolutionManual.value = sol;
  }

  const exec = issueSolutionExecution.value.execution;
  if (exec) {
    if (filteredExecutions.value.includes(exec)) {
      selectedExecution.value = exec;
    } else {
      selectedExecution.value = "Otros";
      customExecution.value = exec;
    }
  }

  await getCameras();
});

const getCameras = async () => {
  cameras.value = [];
  if (issueCopy.value.samplingPoint?.id) {
    const samplingPoint = await getSamplingPointById(issueCopy.value.samplingPoint.id);
    if ((samplingPoint.station as Station)?.id) {
      const camerasConfiguration = await getCamerasConfigurationByStationId(
        (samplingPoint.station as Station).id
      );
      camerasConfiguration?.forEach((_) => {
        cameras.value.push({ label: _.camera.code, value: _.camera.code, modele: _.modele });
      });
      customer.value = samplingPoint.container.holder;
    }
  }
};

const setDiagnosis = () => {
  if (
    issueCopy.value.reviewStatus === "UNREVIEWED" &&
    diagnosisCopy.value.status !== "UNREVIEWED"
  ) {
    ElMessage.error("Es necesario que la incidencia se de como revisada.");
    diagnosisCopy.value.status = "UNREVIEWED";
  }
};

const beforeLeave = (newName: string) => {
  if (newName === "third") {
    const notDiagnosis =
      (!diagnosisCopy.value.diagnosis_automatic && !selectedDiagnosisManual.value) ||
      (!diagnosisCopy.value.solution_proposal_automatic && !selectedSolutionManual.value) ||
      diagnosisCopy.value.status != "REVIEWED";

    if (notDiagnosis) {
      ElMessage.warning(
        `${t("warning.notIssue", { type: `"${t("label.diagnosis")}"`.toLowerCase() })}`
      );
      return false;
    }
  }
  return true;
};

const saveIssue = async () => {
  diagnosisCopy.value.diagnosis_manual =
    selectedDiagnosisManual.value === "Otros"
      ? customDiagnosisManual.value
      : selectedDiagnosisManual.value;

  diagnosisCopy.value.solution_proposal_manual =
    selectedSolutionManual.value === "Otros"
      ? customSolutionManual.value
      : selectedSolutionManual.value;

  issueSolutionExecution.value.execution =
    selectedExecution.value === "Otros" ? customExecution.value : selectedExecution.value;

  if (issueCopy.value.reviewStatus === "REVIEWED" && diagnosisCopy.value.status === "UNREVIEWED") {
    issueCopy.value.statusIssue = "IS-REVIEWED";
  } else if (
    issueCopy.value.reviewStatus === "REVIEWED" &&
    diagnosisCopy.value.status !== "UNREVIEWED" &&
    (issueSolutionExecution.value.status === "UNREVIEWED" ||
      issueSolutionExecution.value.status === undefined)
  ) {
    issueCopy.value.statusIssue = `DI-${diagnosisCopy.value.status}`;
  } else if (
    issueCopy.value.reviewStatus === "REVIEWED" &&
    diagnosisCopy.value.status === "REVIEWED" &&
    (issueSolutionExecution.value.status !== "UNREVIEWED" || !issueSolutionExecution.value.status)
  ) {
    issueCopy.value.statusIssue = `EJ-${issueSolutionExecution.value.status}`;
  }

  diagnosisCopy.value.issueSolutionExecution = issueSolutionExecution.value;
  issueCopy.value.issueDiagnosis = diagnosisCopy.value;
  const newIssue = await putImageLossAlert(issueCopy.value);

  if (newIssue) {
    ElNotification.success({
      message: `${t("success.action")} <br/> ${t("label.issueId")}: <b>${newIssue.code}</b>`,
      offset: 100,
      dangerouslyUseHTMLString: true,
    });
  }
  emit("getIssue");
  cancelIssue();
};

const getClass = (type: string) => {
  return issueCopy.value.origin === "MANUAL" && type === "automatic"
    ? "card-bottom gray"
    : "card-bottom";
};

const cancelIssue = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((activeName).value = $event)),
    class: "demo-tabs",
    "before-leave": beforeLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.mainInfo'),
        name: "first"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.mainInfo")), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("label.issueId")) + ": " + _toDisplayString(issueCopy.value.code ?? "-"), 1)
              ]),
              _createVNode(_component_el_form, {
                ref: "ruleFormRef",
                model: issueCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.samplingPoint')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value?.samplingPoint?.name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.customer')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.value ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.identification')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.origin?.charAt(0).toUpperCase() +
                  issueCopy.value.origin?.slice(1).toLowerCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value?.responsable?.email ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.issueDescription')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.type?.name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.startDate')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issueCopy.value.fromDateTime
                    ? _ctx.$d(
                        new Date(issueCopy.value.fromDateTime.toLocaleString()),
                        "dateTimeNoSecs"
                      ).replace(",", "")
                    : "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      (issueCopy.value?.endDateTime)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.endDateTime')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$d(new Date(issueCopy.value.endDateTime.toLocaleString()), "dateTimeNoSecs").replace(
                    ",",
                    ""
                  )), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.endDateTime')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: issueCopy.value.endDateTime,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issueCopy.value.endDateTime) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.reviewStatus') || 'Estado revisión'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issueCopy.value.reviewStatus,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((issueCopy.value.reviewStatus) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "UNREVIEWED",
                                    label: "Sin revisar"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "REVIEWED",
                                    label: "Revisado"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.priority') || 'Prioridad'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issueCopy.value.priority,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((issueCopy.value.priority) = $event)),
                                placeholder: "Seleccione prioridad",
                                style: {"width":"100%"},
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "LOW",
                                    label: "Bajo"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "MEDIUM",
                                    label: "Medio"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "HIGH",
                                    label: "Alto"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.observations')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueCopy.value.observation,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((issueCopy.value.observation) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            gutter: 10,
            class: "card-bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.incident_cancellation")), 1),
                      _createVNode(_component_el_form, {
                        "label-width": "180px",
                        "label-position": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.statusIssue')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: issueCopy.value.status,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((issueCopy.value.status) = $event)),
                                "active-action-icon": _unref(CircleCheck),
                                "inactive-action-icon": _unref(CircleClose)
                              }, null, 8, ["modelValue", "active-action-icon", "inactive-action-icon"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.note')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueCopy.value.note,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((issueCopy.value.note) = $event)),
                                type: "textarea",
                                rows: 3,
                                maxlength: "250",
                                "show-word-limit": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.camera")), 1),
                      _createElementVNode("div", _hoisted_2, [
                        (cameras.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_el_radio_group, {
                                modelValue: issueCopy.value.camera,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((issueCopy.value.camera) = $event)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameras.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                                      key: item.value,
                                      label: item.value,
                                      disabled: item.value != issueCopy.value.camera
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_4, [
                                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                          (item.modele)
                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 0,
                                                color: "#67C23A"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleCheck))
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 1,
                                                color: "#F56C6C"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleClose))
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "disabled"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("warning.notCameras")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.diagnosis'),
        name: "second"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: _normalizeClass(getClass('automatic')),
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "label-width": "180px",
                "label-position": "left",
                disabled: issueCopy.value.origin === 'MANUAL'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.automatic").toLowerCase()), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(translatedAutomaticDiagnosis)), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_card, {
            class: _normalizeClass(getClass('manual')),
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: diagnosisCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.manual").toLowerCase()), 1),
                    _createVNode(_component_el_switch, {
                      modelValue: diagnosisCopy.value.isManual,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((diagnosisCopy.value.isManual) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(diagnosisCopy.value?.responsable?.email ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: selectedDiagnosisManual.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedDiagnosisManual).value = $event)),
                                disabled: !diagnosisCopy.value.isManual,
                                style: {"width":"100%"},
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDiagnoses.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"]),
                              (selectedDiagnosisManual.value === 'Otros')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: customDiagnosisManual.value,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((customDiagnosisManual).value = $event)),
                                    disabled: !diagnosisCopy.value.isManual,
                                    placeholder: "Escriba el nuevo diagnóstico...",
                                    style: {"margin-top":"10px"}
                                  }, null, 8, ["modelValue", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: diagnosisCopy.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.solution_proposal')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: selectedSolutionManual.value,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedSolutionManual).value = $event)),
                                disabled: !diagnosisCopy.value.isManual,
                                style: {"width":"100%"},
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredExecutions.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"]),
                              (selectedSolutionManual.value === 'Otros')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: customSolutionManual.value,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customSolutionManual).value = $event)),
                                    disabled: !diagnosisCopy.value.isManual,
                                    placeholder: "Escriba la nueva propuesta de solución...",
                                    style: {"margin-top":"10px"}
                                  }, null, 8, ["modelValue", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.status') || 'Estado'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: diagnosisCopy.value.status,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((diagnosisCopy.value.status) = $event)),
                                style: {"width":"100%"},
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (setDiagnosis()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "UNREVIEWED",
                                    label: "Sin Revisar"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "IN_PROGRESS",
                                    label: "En proceso"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "REVIEWED",
                                    label: "Revisado"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.observations')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: diagnosisCopy.value.note,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((diagnosisCopy.value.note) = $event)),
                                maxlength: "100",
                                "show-word-limit": "",
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.solutionExecution'),
        name: "third"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { shadow: "never" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: issueSolutionExecution.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.solutionExecution")), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.execution')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: selectedExecution.value,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedExecution).value = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredExecutions.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (selectedExecution.value === 'Otros')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: customExecution.value,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((customExecution).value = $event)),
                                    placeholder: "Escriba la nueva ejecución de solución...",
                                    style: {"margin-top":"10px"}
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.status') || 'Estado'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issueSolutionExecution.value.status,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((issueSolutionExecution.value.status) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "UNREVIEWED",
                                    label: "No revisado"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "OPEN",
                                    label: "Abierto"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "OBSERVATION",
                                    label: "En observación"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "CLOSE",
                                    label: "Finalizado"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.observations') || 'Observaciones'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueSolutionExecution.value.note,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((issueSolutionExecution.value.note) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: cancelIssue }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveIssue
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})